export class FormatNullValueFilter {
    public static Factory() {
        return function (value: any): string {
            return value ? value : '--';
        };
    }
}
